import { EFeaturesActionType, IFeaturePropertiesUpdateParameters } from './types';
import { actionGenerator } from '../../../common/utils/redux/actionGenerator';

export const updateFeatureProperties = actionGenerator<
  EFeaturesActionType.FeaturePropertiesUpdated,
  IFeaturePropertiesUpdateParameters
>(EFeaturesActionType.FeaturePropertiesUpdated);
